import {
  IItem,
  IPrismicTitleLeafImageTextRowItem,
  ITitleLeafImageTextRow,
} from './types';

export const mapTitleLeafImageTextRow = ({
  prismicContent,
}): ITitleLeafImageTextRow => {
  const items: IItem[] = prismicContent.items.map(
    ({
      image: { url: image, alt },
      picture_on_right: hasPictureOnRight,
      text,
    }: IPrismicTitleLeafImageTextRowItem) => {
      return {
        image,
        alt,
        hasPictureOnRight,
        text,
      };
    },
  );
  const { title } = prismicContent.primary;

  const titleLeafImageTextRow: ITitleLeafImageTextRow = {
    title,
    items,
  };

  return titleLeafImageTextRow;
};
